// @flow

import { selectCurrentService } from 'app/developer-v3/store/build/selectors';

import type { AppService } from 'app/developer-v3/types';
import type { ServiceType } from 'app/developer-v3/types/service';
export { updateOverrideWithService } from 'app/developer-v3/Actions';

export const updateService = (
  serviceType: ServiceType,
  serviceUpdate: AppService,
  state: {}
) => ({
  operation: { perform: {} },
  ...selectCurrentService(state),
  ...serviceUpdate,
});
